import { httpV2 } from "@/api";

const Qs = require("qs");

/**
 * @summary Promise que busca a lista de registros, com potência e velocidade do vento.
 * Categorizadas em Operação e Full Course.
 * @param params Objeto com id do elemento de monitoração da turbina, data de inicio e data de fim da pesquisa.
 * @returns Promise da lista de registros, com potência e velocidade do vento. Categorizadas em Operação e Full Course.
 */
const GetPitchRegisters = function(params = {
	turbineMonitoringElementId: 0,
	startDateTime:              "",
	endDateTime:                "",
})
{
	const parameters = params;
	return httpV2.get("/PitchSignalRegisters",
	 {
			params:           parameters,
			paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" })
		});
};

export default { GetPitchRegisters };